import React from "react";

export const DropdownWrapper = React.memo(
  ({ visible, children }: { visible: boolean; children: React.ReactNode }) => {
    return (
      <div
        onClick={(e) =>
          // Prevent checkbox from being toggled when the dropdown is selected.
          e.stopPropagation()
        }
        style={{
          marginLeft: "auto",
        }}>
        {visible && (
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}>
            {children}
          </div>
        )}
      </div>
    );
  },
);
